
const COLLECTIONS_PANEL_SELECTOR = '.multi-collection-filter__collections .collections__panel'
const BUTTON_SELECTOR = 'button[data-collection-handle]'

class MultiCollectionFilter extends HTMLElement {

  constructor() {
    super()
    this.buttonElems = []
    this.panelElems = []
  }

  connectedCallback() {
    this._initElems()
    const firstPane = this.panelElems[0]
    firstPane.classList.remove('hide')
  }

  _setButtonActive(collectionHandle) {
    for(const button of this.buttonElems) {
      if (button.dataset.collectionHandle === collectionHandle) {
        button.dataset.active = true
      } else {
        button.dataset.active = false
      }
    }
  }

  _displayCollectionPane(collectionHandle) {
    for(const panel of this.panelElems) {
      if (panel.dataset.collectionHandle === collectionHandle) {
        panel.classList.remove('hide')
      } else {
        panel.classList.add('hide')
      }
    }
  }

  _changeActiveCollection(e) {
    const collectionHandle = e.target.dataset.collectionHandle;
    this._displayCollectionPane(collectionHandle);
    this._setButtonActive(collectionHandle);
  }

  /*
  Set all the button and panel elements.
  Then add event listeners to the buttons.
  */
  _initElems() {
    this.buttonElems = this.querySelectorAll(BUTTON_SELECTOR)
    this.panelElems = this.querySelectorAll(COLLECTIONS_PANEL_SELECTOR)
    for (const buttonElem of this.buttonElems) {
      buttonElem.addEventListener('click', this._changeActiveCollection.bind(this))
    }
  }
}

customElements.define("multi-collection-filter", MultiCollectionFilter);

export {MultiCollectionFilter};
